import React from 'react';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { FormGroup, FormControl, FormLabel, Row, Col } from "react-bootstrap";
import { FiLock, FiUnlock, FiTrash2, FiX } from "react-icons/fi";
import moment from 'moment';
import { isSafari } from 'react-device-detect';
import { plansService, employeesService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import InlineAlert from "components/InlineAlert";
import TimeInputWithArrows from "components/TimeInputWithArrows";
import Switch from "components/Switch";
import * as shiftsActions from 'actions/shiftsActions';
import { convertToUTC, convertFromUTC } from 'utils/datetime';
import { withTranslation } from 'react-i18next';
import { planGroupScope } from 'utils/undo/scopeKeys';
import {
	buildUpdateInverse,
	snapshotFromShiftPlan,
} from 'utils/undo/planUndoHelpers';

class PlanShiftEdit extends React.Component {

	constructor(props) {
		super(props);
		// console.log(props);

		const shift_plan = props.plan.shift_plan;
		const shift = shift_plan.shift;

		if (shift_plan.function) {
			shift.function_id = shift_plan.function.id;
		}

		if (shift_plan.time_intervals && shift_plan.time_intervals.length > 0) {
			shift.time_intervals = shift_plan.time_intervals;
		}

		if (shift_plan.comments) {
			shift.comments = shift_plan.comments;
		}

		var selected_ubications = shift_plan.ubications ? shift_plan.ubications : [];

		this.state = {
			isLoading: false,
			submitted: false,
			employee_functions: [],
			employee_ubications: [],
			errors: {},
			new_interval: {},
			new_interval_errors: {},
			shift,
			locked: true,
			temp_ubication: {},
			selected_ubications,
			new_ubication_errors: {},
		};
	}

	componentDidMount() {
		this.getEmployeeFunctions();
		this.getEmployeeUbications();
	}

	getEmployeeFunctions = async () => {
		const { plan } = this.props;
		const employee_id = plan.employee.id;
		const employee_functions = await employeesService.getFunctions(employee_id);

		if (employee_functions.ok) {
			this.setState({
				employee_functions
			});
		}
	}

	getEmployeeUbications = async () => {
		const { plan } = this.props;
		const employee_id = plan.employee.id;
		const employee_ubications = await employeesService.getUbications(employee_id);
		//console.log(employee_ubications);

		if (employee_ubications.ok) {
			this.setState({
				employee_ubications
			});
		}
	}

	handleChange = event => {
		const { shift } = this.state;

		this.setState({
			shift: {
				...shift,
				[event.target.id]: event.target.value
			},
		});
	}

	checkValidField = (name) => {
		return (this.state.submitted && this.state.errors[name] !== undefined && this.state.errors[name] !== '');
	}

	buildAssignmentPatch = () => {
		const { shift, selected_ubications, employee_functions, locked } = this.state;
		const patch = {
			time_intervals: shift.time_intervals,
			comments: shift.comments,
			locked,
		};

		if (shift.function_id) {
			const functionId = parseInt(shift.function_id, 10);
			patch.function_id = functionId;
			const employeeFunction = employee_functions.find(
				(item) => item.function.id === functionId
			);
			if (employeeFunction) {
				patch.function = employeeFunction.function;
			}
		}

		if (selected_ubications.length > 0) {
			patch.ubications = selected_ubications;
		}

		return patch;
	};

	prepareTimeIntervalsToSubmit = () => {
		const { shift } = this.state;

		return shift.time_intervals && shift.time_intervals.map((time_interval) => {

			const new_interval = {
				start: time_interval.start,
				end: time_interval.end,
				time_type_id: time_interval.time_type_id,
			}

			if (!isNaN(time_interval.id))
				new_interval.id = time_interval.id;

			if (new_interval.time_type_id === undefined)
				new_interval.time_type_id = time_interval.time_type.id;

			return new_interval
		}
		);
	}

	handleSubmit = async event => {
		event.preventDefault();
		const { shift, selected_ubications, locked } = this.state;
		const { plan } = this.props;

		this.setState({ isLoading: true });
		let response = '';
		const props = this.props;

		// console.log(plan);
		const isOvernight = plan.shift_plan.time_intervals_overnight && plan.shift_plan.time_intervals_overnight.length > 0;
		const prevDay = moment(plan.day, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD");
		const originDay = isOvernight ? prevDay : plan.day;
		const before = snapshotFromShiftPlan(
			plan.shift_plan,
			plan.employee.id,
			originDay
		);

		const shift_plan = {
			id: plan.shift_plan.id,
			day: isOvernight ? prevDay : plan.day,
			employee_id: plan.employee.id,
			function_id: shift.function_id,
			comments: shift.comments,
			locked,
			shift_id: plan.shift_plan.shift.id,
			time_intervals: this.prepareTimeIntervalsToSubmit()
		}

		// console.log(shift_plan);


		if (selected_ubications.length > 0) {
			const selected_ubications_ids = [];

			selected_ubications.map(ubication => {
				selected_ubications_ids.push(ubication.id);
				return true;
			});

			shift_plan.ubication_ids = selected_ubications_ids;

			// console.log(shift_plan.ubication_ids);
		}

		// put
		try {
			// eslint-disable-next-line no-console
			console.debug('[EDIT] updateAssignment payload', { shift_plan });
		} catch (_) { }
		response = await plansService.updateAssignment(shift_plan);


		try {
			// eslint-disable-next-line no-console
			console.debug('[EDIT] updateAssignment response', { ok: response?.ok, errors: response?.errors });
		} catch (_) { }
		const update_employee_ids = [plan.employee.id];

		if (response.ok) {
			this.setState({
				isLoading: false,
				errors: {},
			});

			const after = {
				...before,
				function_id: shift.function_id
					? parseInt(shift.function_id, 10)
					: before.function_id,
				comments: shift.comments,
				locked,
				time_intervals: shift_plan.time_intervals,
				ubication_ids:
					selected_ubications.length > 0
						? shift_plan.ubication_ids
						: [],
			};
			const inverse = buildUpdateInverse({
				id: plan.shift_plan.id,
				before,
				after,
				employeeId: plan.employee.id,
			});

			if (props.groupId && props.registerUndoAndShowToast) {
				props.registerUndoAndShowToast({
					scope: planGroupScope(props.groupId),
					type: "UPDATE",
					messageKey: "undo.plan.shiftUpdated",
					inverse: inverse || undefined,
					refresh: { employeeIds: [plan.employee.id] },
				});
			} else {
				toastr.success(props.t('common.success'), props.t('common.changesSaved'));
			}

			if (props.patchPlanShiftAfterEdit) {
				props.patchPlanShiftAfterEdit(plan, this.buildAssignmentPatch());
			}

			try {
				// eslint-disable-next-line no-console
				console.debug('[EDIT] calling updateEmployeeIdsAndGetAllAssignments', { update_employee_ids });
			} catch (_) { }

			await props.updateEmployeeIdsAndGetAllAssignments(update_employee_ids);
			props.handleClose();
		}
		else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response)
			});
		}
	}

	handleLockedChange = (event) => {
		this.setState({ locked: event.target.checked });
	}

	handleAddChange = event => {
		this.setState({
			[event.target.id]: event.target.value
		});
	}

	handleChangeNewInterval = event => {
		const { new_interval } = this.state;

		this.setState({
			new_interval: {
				...new_interval,
				[event.target.id]: event.target.value
			},
		});
	}


	addTimeInterval = () => {
		const { shift, new_interval } = this.state;
		const hourFormat = "HH:mm"; // Formato 24 horas correcto
		let isValid = true;
		const new_interval_errors = {};
		const time_type = this.props.select_time_types.find(dt => dt.id === parseInt(new_interval.time_type_id));

		if (!time_type) {
			isValid = false;
			new_interval_errors.time_type_id = false;
		}

		if (!new_interval.start) {
			isValid = false;
			new_interval_errors.start = false;
		}

		if (!new_interval.end) {
			isValid = false;
			new_interval_errors.end = false;
		}

		if (isValid) {
			new_interval.time_type = time_type;

			// Convertimos la hora ingresada a UTC antes de almacenarla
			const startUTC = convertToUTC(new_interval.start);
			const endUTC = convertToUTC(new_interval.end);

			// Crear el nuevo intervalo con las horas convertidas a UTC
			const converted_interval = {
				...new_interval,
				start: startUTC,
				end: endUTC,
			};

			let time_intervals = shift.time_intervals ? [...shift.time_intervals, converted_interval] : [converted_interval];

			// Ordenamos los intervalos convertidos a UTC
			time_intervals.sort((a, b) => {
				const aTime = moment(a.start, hourFormat);
				const bTime = moment(b.start, hourFormat);
				return aTime.isBefore(bTime) ? -1 : bTime.isBefore(aTime) ? 1 : 0;
			});

			this.setState({
				shift: {
					...shift,
					time_intervals,
				},
				new_interval: {
					time_type_id: '',
					start: '',
					end: '',
				},
				new_interval_errors: {},
			});
		} else {
			this.setState({
				new_interval_errors,
			});
		}
	};


	removeTimeInterval = (interval) => {
		const { shift } = this.state;

		this.setState({
			shift: {
				...shift,
				time_intervals: shift.time_intervals.filter(item => item.start !== interval.start && item.end !== interval.end)
			}
		});
	}

	handleChangeInterval = (event, index) => {
		const { shift } = this.state;
		const rawValue = event.target.value;
		const key = event.target.id.replace(`_${index}`, "");

		if (rawValue === "" || !moment(rawValue, "HH:mm", true).isValid()) {
			return;
		}

		const convertedTime = convertToUTC(rawValue);

		this.setState({
			shift: {
				...shift,
				time_intervals: shift.time_intervals.map((intr, j) =>
					j === index ? { ...intr, [key]: convertedTime } : intr
				),
			},
		});
	};


	getTimeIntervalCards = () => {
		const { t } = this.props;
		return this.state.shift.time_intervals.map((interval, i) => {
		const { submitted, errors } = this.state;
		var hasError = false;

		if (submitted && Object.keys(errors).length > 0) {
			// console.log(errors[`time_intervals[${i}].start`]);
			hasError = this.checkValidField(`time_intervals[${i}].start`) || this.checkValidField(`time_intervals[${i}].end`);
		}
		const start = convertFromUTC(interval.start);
		const end = convertFromUTC(interval.end);

		return (
			<div
				key={i}
				className={`plan-shift-edit__interval-card ${hasError ? "hasError" : ""}`}
			>
				<div className="plan-shift-edit__interval-card-field">
					<span className="plan-shift-edit__interval-card-label">{t('common.type')}</span>
					<strong className="plan-shift-edit__interval-card-value">
						{t(`timeTypes.names.${interval.time_type.name}`, { defaultValue: interval.time_type.name })}
					</strong>
				</div>
				<div className="plan-shift-edit__interval-card-field">
					<span className="plan-shift-edit__interval-card-label">{t('common.start')}</span>
					<TimeInputWithArrows
						id={`start_${i}`}
						value={start}
						onChange={(e) => this.handleChangeInterval(e, i)}
						isInvalid={hasError}
						showDecorators={false}
						required
						nextInputId={`end_${i}`}
					/>
				</div>
				<div className="plan-shift-edit__interval-card-field">
					<span className="plan-shift-edit__interval-card-label">{t('common.end')}</span>
					<TimeInputWithArrows
						id={`end_${i}`}
						value={end}
						onChange={(e) => this.handleChangeInterval(e, i)}
						isInvalid={hasError}
						showDecorators={false}
						required
					/>
				</div>
				<div className="plan-shift-edit__interval-card-actions">
					<button
						type="button"
						className="btn btn-icon"
						onClick={() => this.removeTimeInterval(interval)}
						aria-label={t('plan.shiftEdit.deletePeriod')}
					>
						<FiTrash2 />
					</button>
				</div>
				{hasError && (
					<div className="plan-shift-edit__interval-card-error">
						{errors[`time_intervals[${i}].start`]}
					</div>
				)}
			</div>
		)
	});
	}

	// ubicaciones empleado

	getSelectedUbications = () => this.state.selected_ubications.map((item) => {
		return (
			<li key={item.id} className="tag-default tag-delete">
				{item.name}
				<button type="button" onClick={() => this.removeUbication(item.id)} className="btn-tag-delete btn-transparent"><FiX /></button>
			</li>
		)
	});

	addUbication = () => {
		let { selected_ubications, temp_ubication, employee_ubications } = this.state;
		let isValid = true;
		let employee_ubication;
		const new_ubication_errors = {};

		if (temp_ubication === undefined) {
			isValid = false;
		}
		else {
			employee_ubication = employee_ubications.find(item => item.ubication.id === parseInt(temp_ubication));

			if (employee_ubication === undefined) {
				isValid = false;
				new_ubication_errors.ubication = false;
			}
		}

		if (isValid) {
			// check if ubication already exists
			const exists = selected_ubications.find(item => item.id === parseInt(temp_ubication));

			if (!exists) {
				selected_ubications = selected_ubications.concat(employee_ubication.ubication);
			}

			this.setState({
				selected_ubications,
				new_ubication_errors: {},
				temp_ubication: {},
			});
		}
		else {
			this.setState({
				new_ubication_errors,
			});
		}
	}
	removeUbication = (idUbication) => {
		this.setState((prevState, props) => {
			return {
				selected_ubications: prevState.selected_ubications.filter(item => item.id !== parseInt(idUbication))
			};
		});
	}


	render() {
		const { shift, employee_functions, employee_ubications, errors, new_interval, new_interval_errors, new_ubication_errors, temp_ubication, locked } = this.state;
		const { plan, select_time_types, t } = this.props;

		const optionTimeTypeList = select_time_types.length > 0 && select_time_types.map((item, i) => {
			var isOk = false;
			// si es ausencia por horas, solo se muestran tipos de tiempo de no trabajo
			if (shift.allow_hourly_absence_request) {
				if (!item.work_time) {
					isOk = true;
				}
			} else {
				isOk = true;
			}

			if (isOk) {
				return (
					<option key={i} value={item.id}>{item.name}</option>
				)
			}
			else {
				return ''
			}

		}, this);

		const optionFunctionList = employee_functions.length > 0 && employee_functions.map((item, i) => {
			const func = item.function;

			return (
				<option key={i} value={func.id}>{func.name}</option>
			)
		}, this);

		const optionUbicationList = employee_ubications.length > 0 && employee_ubications.map((item, i) => {
			const ubication = item.ubication;

			return (
				<option key={i} value={ubication.id}>{ubication.name}</option>
			)
		}, this);

		const employee = plan.employee.name + " " + plan.employee.surname;
		const day = moment(plan.day).format("DD MMMM YYYY");


		// fix de input time para safari
		const isEmptyStartSafari = isSafari && (new_interval.start === null || new_interval.start === undefined);
		const isEmptyEndSafari = isSafari && (new_interval.end === null || new_interval.end === undefined);
		const new_interval_start = isEmptyStartSafari ? "00:00" : new_interval.start;
		const new_interval_end = isEmptyEndSafari ? "00:00" : new_interval.end;

		return (

			<form onSubmit={this.handleSubmit}>
				<div className="modal-body plan-shift-edit">

					<Row className="plan-shift-head">
						<Col sm={6} >
							<strong>{t('common.employee')}</strong> <br />{employee}
						</Col>
						<Col sm={6} >
							<strong>{t('plan.shiftEdit.date')}</strong> <br />{day}
						</Col>
					</Row>

					{employee_functions.length > 0 &&
						<FormGroup className="form-group" controlId="function_id">
							<FormLabel>{t('plan.shiftEdit.employeeFunction')}</FormLabel>
							<FormControl
								placeholder={t('plan.shiftEdit.selectFunction')}
								isInvalid={this.checkValidField('function_id')}
								onChange={this.handleChange}
								value={shift.function_id}
								as="select"
							>
								<option value="">{t('common.select')}</option>
								{optionFunctionList}
							</FormControl>
						</FormGroup>
					}

					{employee_ubications.length > 0 && (
						<div className="row-ubications">
							<div className="flex-group mb10">
								<FormGroup className="form-group" controlId="temp_ubication">
									<FormLabel>{t('plan.shiftEdit.employeeUbications')}</FormLabel>
									<FormControl
										type="text"
										value={temp_ubication}
										placeholder={t('plan.shiftEdit.selectUbication')}
										onChange={this.handleAddChange}
										// isInvalid={new_ubication_errors.ubication !== undefined}
										as="select"
									>
										<option value="">{t('plan.shiftEdit.selectUbication')}</option>
										{optionUbicationList}
									</FormControl>
								</FormGroup>
								<button type="button" onClick={this.addUbication} className="btn btn-primary">{t('common.add')}</button>
							</div>
							<ul className="list-tags">
								{this.getSelectedUbications()}
							</ul>
						</div>)
					}

					<FormGroup className="form-group" controlId="comments">
						<FormLabel>{t('common.observations')}</FormLabel>
						<FormControl
							placeholder={t('common.observationsPlaceholder')}
							isInvalid={this.checkValidField('comments')}
							onChange={this.handleChange}
							value={shift.comments}
							type="textarea"
						/>
						<FormControl.Feedback type="invalid">
							{this.state.errors.comments}
						</FormControl.Feedback>
					</FormGroup>

					<div className={`plan-shift-edit-lock-setting ${locked ? "is-locked" : ""}`}>
						<div className="plan-shift-edit-lock-icon" aria-hidden="true">
							{locked ? <FiLock /> : <FiUnlock />}
						</div>
						<label className="plan-shift-edit-lock-copy" htmlFor="plan_shift_locked">
							<strong>{t('plan.shiftEdit.lockTitle')}</strong>
							<span>
								{locked
									? t('plan.shiftEdit.lockedHelp')
									: t('plan.shiftEdit.unlockedHelp')}
							</span>
						</label>
						<Switch
							controlId="plan_shift_locked"
							isOn={locked}
							handleToggle={this.handleLockedChange}
						/>
					</div>

					<div className="time-intervals">
						<h3 className="subtitle">{t('plan.shiftEdit.timePeriods')}</h3>

						<div className="row-special-days flex-between gap10">
							<FormGroup className="form-group" controlId="time_type_id">
								<FormLabel>{t('plan.shiftEdit.timeType')}</FormLabel>
								<FormControl
									placeholder={t('plan.shiftEdit.selectType')}
									isInvalid={new_interval_errors.time_type_id !== undefined}
									onChange={this.handleChangeNewInterval}
									value={new_interval.time_type_id}
									as="select"
								>
									<option value="">{t('common.select')}</option>
									{optionTimeTypeList}
								</FormControl>
							</FormGroup>

							<FormGroup controlId="start" className="form-group form-group-time">
								<FormLabel>{t('common.start')}</FormLabel>
								<TimeInputWithArrows
									id="start"
									value={new_interval_start}
									onChange={this.handleChangeNewInterval}
									className={`${isEmptyStartSafari ? "is-safari is-empty" : ""}`}
									isInvalid={new_interval_errors.start !== undefined}
									showDecorators={false}
									nextInputId="end"
								/>
							</FormGroup>


							<FormGroup controlId="end" className="form-group form-group-time">
								<FormLabel>{t('common.end')}</FormLabel>
								<TimeInputWithArrows
									id="end"
									value={new_interval_end}
									onChange={this.handleChangeNewInterval}
									className={`${isEmptyEndSafari ? "is-safari is-empty" : ""}`}
									isInvalid={new_interval_errors.end !== undefined}
									showDecorators={false}
								/>
							</FormGroup>

							<button type="button" className="btn btn-primary btn-add wx-128" onClick={this.addTimeInterval}>{t('plan.shiftEdit.addPeriod')}</button>

						</div>

						{errors.time_intervals && (
							<InlineAlert variant="error" className="mt15 mb15">
								{errors.time_intervals}
							</InlineAlert>
						)}

						{shift.time_intervals && shift.time_intervals.length > 0 && (
							<div className="plan-shift-edit__interval-cards">
								{this.getTimeIntervalCards()}
							</div>
						)}
					</div>

					{this.state.errors && this.state.errors.shift_id && (
						<InlineAlert variant="error">
							{this.state.errors.shift_id}
						</InlineAlert>
					)}

				</div>

				<div className="modal-footer">
					<button type="button" onClick={this.props.handleClose} className="btn btn-outline-primary">{t('common.cancel')}</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={t('common.save')}
						loadingText={t('common.saving')}
					/>
				</div>
			</form>
		)
	}
}


const mapStateToProps = (reducers) => {
	return {
		...reducers.calendarsReducer,
		...reducers.timesReducer,
		...reducers.shiftsReducer,
		loading: reducers.shiftsReducer.loading
	}
};

export default connect(mapStateToProps, shiftsActions)(withTranslation()(PlanShiftEdit))
